import { EDealType, EOfficeType } from 'shared/types/filters';

import { MAP_OFFICE_TYPE_WITH_DEAL_TYPE } from '../constants';

export const getAvailableOfficeTypes = (dealType: EDealType): EOfficeType[] => MAP_OFFICE_TYPE_WITH_DEAL_TYPE[dealType];
